import { MARK_RELEASE_NOTE_OPENED } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (token: string, noteIds: string[]) =>
  fetch(MARK_RELEASE_NOTE_OPENED, {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + token },
    body: JSON.stringify({ noteIds }),
  }).then(errorHandler)
